/* 배너 상품 순환 — sections/discount-banner.liquid (Product list: Banners)
   컬렉션이 선택된 배너 블록에서 같은 data-rotator-index 를 가진 텍스트·이미지 아이템을
   일정 간격으로 교대 노출한다. 호버 중에는 일시정지, prefers-reduced-motion 이면 순환 안 함. */
if (!customElements.get('discount-banner-rotator')) {
  customElements.define('discount-banner-rotator', class extends HTMLElement {
    connectedCallback() {
      this.interval = parseInt(this.dataset.interval, 10) || 5000;
      this.items = Array.from(this.querySelectorAll('[data-rotator-index]'));
      this.count = this.items.reduce((max, el) => Math.max(max, parseInt(el.dataset.rotatorIndex, 10) + 1), 0);
      this.index = 0;
      if (this.count < 2 || this.dataset.autorotate !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.addEventListener('pointerenter', () => this.pause());
      this.addEventListener('pointerleave', () => this.play());
      this.play();
    }

    disconnectedCallback() {
      this.pause();
    }

    play() {
      this.pause();
      this.timer = setInterval(() => this.next(), this.interval);
    }

    pause() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    next() {
      this.index = (this.index + 1) % this.count;
      this.items.forEach((el) => {
        el.hidden = parseInt(el.dataset.rotatorIndex, 10) !== this.index;
      });
    }
  });
}
